import type React from "react";

interface NativePdfViewerProps {
    file: {
        id: string;
        url: string;
    };
}

export const NativePdfViewer: React.FC<NativePdfViewerProps> = ({ file }) => {
    return (
        <div className="relative h-full w-full overflow-hidden">
            <iframe
                src={file.url}
                className="h-full w-full border-0"
                title={file.id}
                style={{
                    backgroundColor: "#525659",
                }}
            />
        </div>
    );
};
